class ProductCard extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLImageElement} */
    this.imageEl = this.querySelector(".product-card__image img:nth-child(1)");
    /** @type {HTMLImageElement} */
    this.hoverImage = this.querySelector(".product-card__image img:nth-child(2)");
    /** @type {string} */
    this.secondaryImageURL = this.hoverImage.src;
    /** @type {string} */
    this.secondaryImageSrcset = this.hoverImage.srcset;
    /** @type {HTMLButtonElement[]} */
    this.swatchElements = this.querySelectorAll(".product-card__swatch")
    /** @type {HTMLButtonElement} */
    this.firstSwatchEl = this.querySelector(".product-card__swatch.active")
  }

  connectedCallback() {
    // Set up event listeners
    this.swatchElements.forEach((swatchEl) => {
      swatchEl.addEventListener("mouseenter", () => {
        this.onSwatchHover("enter", swatchEl);
      });
      swatchEl.addEventListener("mouseleave", () => {
        this.onSwatchHover("exit", swatchEl);
      });
    })
  }

  /**
   * 
   * @param {string} type - enter or exit
   * @param {HTMLButtonElement} swatchEl
   */
  onSwatchHover(type = "enter", swatchEl) {
    console.log(swatchEl);
    switch (type) {
      case "enter":
        // Show variant image
        const { variantImage } = swatchEl.dataset;
        this.hoverImage.src = variantImage;
        this.hoverImage.srcset = variantImage;
        if(swatchEl != this.firstSwatchEl) {
          this.firstSwatchEl.classList.remove("active");
        }
        break;
      case "exit": 
       // Show default hover image
       this.hoverImage.src = this.secondaryImageURL;
       this.hoverImage.srcset = this.secondaryImageSrcset;
       this.firstSwatchEl.classList.add("active");
       break;
      default: 
       return false;
    }
    
  }
}

customElements.define("product-card", ProductCard)